import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    GlobalSearchCategoryResponse,
    GlobalSearchTableName
} from '../models/GlobalSearchCategory-model';
import {
    GlobalSearchRow,
    GlobalSearchTableResponse
} from '../models/GlobalSearchTableResponse-model';
import { GlobalSearchByWinOls } from '../models/GlobalSearchByWinOls-model';

export interface WinOlsSearchPage {
    content: GlobalSearchByWinOls[];
    totalElements: number;
    totalPages: number;
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {

    constructor(
        private http: HttpClient,
        @Inject('API_URL') private apiUrl: string
    ) {}

    search(search: string): Observable<GlobalSearchCategoryResponse> {
        const params = new HttpParams().set('search', search);
        return this.http.get<GlobalSearchCategoryResponse>(`${this.apiUrl}/global/search`, { params });
    }

    searchByWinOls(winOls: string, pageNumber = 0, pageSize = 10): Observable<WinOlsSearchPage> {
        const params = new HttpParams()
            .set('winOls', winOls)
            .set('pageNumber', pageNumber)
            .set('pageSize', pageSize);
        return this.http.get<WinOlsSearchPage>(`${this.apiUrl}/global/searchByWinOls`, {params});
    }

    searchInTable(
        table: GlobalSearchTableName,
        search: string,
        pageNumber = 0,
        pageSize = 10
    ): Observable<GlobalSearchTableResponse<GlobalSearchRow>> {
        const params = new HttpParams()
            .set('search', search)
            .set('table', table)
            .set('pageNumber', String(pageNumber))
            .set('pageSize', String(pageSize));
        return this.http.get<GlobalSearchTableResponse<GlobalSearchRow>>(
            `${this.apiUrl}/global/search-in-table`,
            { params }
        );
    }
}
